// @flow

// eslint-disable-next-line import/no-extraneous-dependencies
import typeToReducer from 'type-to-reducer'

import { SET_DEBUG_MODE, SET_DEBUG_UNLOCKED } from '../actions'

export type DebugState = {
  enabled: boolean,
  unlocked: boolean,
}

const initialState: DebugState = {
  enabled: false,
  unlocked: false,
}

const debug: DebugState = typeToReducer(
  {
    [SET_DEBUG_MODE]: (state, { payload }) => ({
      ...state,
      enabled: payload.enabled,
    }),
    [SET_DEBUG_UNLOCKED]: (state, { payload }) => ({
      ...state,
      unlocked: payload.unlocked,
    }),
  },
  initialState,
)

export { debug }
